// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__lF3bk","badges":"styles_badges__3gk2s"};